import { render } from "./MochiCharacter.vue?vue&type=template&id=1ed36310&scoped=true"
import script from "./MochiCharacter.vue?vue&type=script&lang=js"
export * from "./MochiCharacter.vue?vue&type=script&lang=js"

import "./MochiCharacter.vue?vue&type=style&index=0&id=1ed36310&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed36310"]])

export default __exports__